import ClientInvoiceService from '../../../../Services/ClientInvoiceService';

export default class ClientInvoiceViewDescription {
  static invoiceService = ClientInvoiceService.GetInvoicePdfById;
  static title = 'Client Invoice Preview';
  static fileNamePrefix = 'client_invoice';
  static attachInvoiceServiceFunction = ClientInvoiceService.AttachReportAsync;
}
